<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-3 sidebar-project bg-custom-blue py-3">

        <!-- Header left sidebar -->
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4 class="mb-0">{{ $t("views.nav.manageProjects") }}</h4>
          <button @click="openModal(false, '', 'project', 'add')" type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#projectEditModal">+ {{ $t("general.add") }}</button>
        </div>

        <!-- Time-Filter -->
        <div class="row mt-4">
          <div class="col-6">
            <div class="dropdown">
              <button class="btn btn-sm dropdown-toggle bg-white text-start" style="width: 200px" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <span>{{ formatDate(new Date(filterValidFrom)) }} &nbsp;-&nbsp; {{ formatDate(new Date(filterValidTo)) }}</span>
              </button>
              <div class="dropdown-menu border-secondary p-3">
                <div class="row">
                  <div class="col-12">
                    <button @click="filterProjects(new Date().toISOString().slice(0, 10), new Date().toISOString().slice(0, 10))" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">{{ $t("general.today") }}</button>
                    <button @click="filterProjects((new Date().getFullYear() + 1).toString() + '-01-01', (new Date().getFullYear() + 1).toString() + '-12-31')" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">{{ new Date().getFullYear() + 1 }}</button>
                    <button @click="filterProjects(new Date().getFullYear().toString() + '-01-01', new Date().getFullYear().toString() + '-12-31')" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">{{ new Date().getFullYear() }}</button>
                    <button @click="filterProjects((new Date().getFullYear() - 1).toString() + '-01-01', (new Date().getFullYear() - 1).toString() + '-12-31')" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">{{ new Date().getFullYear() - 1 }}</button>
                  </div>
                </div>
                <hr class="dropdown-divider">
                <div class="row">
                  <div class="col-6">
                    <label for="filterValidFrom" class="form-label">{{ $t("views.kpi.periods.from") }}:</label>
                    <input v-model="filterValidFrom" type="date" class="form-control form-control-sm" id="filterValidFrom">
                  </div>
                  <div class="col-6">
                    <label for="filterValidTo" class="form-label">{{ $t("views.kpi.periods.to") }}:</label>
                    <input v-model="filterValidTo" type="date" class="form-control form-control-sm" id="filterValidTo">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <button @click="filterProjects(filterValidFrom, filterValidTo)" class="btn btn-sm btn-outline-primary mt-3" type="button">{{ $t("views.kpi.periods.filter") }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Search & Slider -->
        <div class="row mt-1">
          <div class="col-12">
            <div class="d-flex justify-content-between align-items-center">
              <!-- Search -->
              <div class="me-3" style="width: 200px"> <input v-model="searchText" type="text" :placeholder="$t('general.placeholderSearch')" class="form-control form-control-sm mt-1" /></div>
              <!-- Level-Slider from 2 to maxTreeLevel -->
              <div class="d-flex flex-column align-items-start mb-2">
                <div class="fs-08 text-muted mb-1"> {{ $t('general.treeViewLevels') }}: {{ autoOpenDepth }} </div>
                <div class="d-flex align-items-center gap-2">
                  <input type="range" class="form-range foc-range" min="2" :max="maxTreeDepth" step="1" v-model="autoOpenDepth" :key="sliderKey">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <ProjectTree v-if="'nodes' in projects && projects.nodes.length" :node="projects" :depth="0" mode="manage" :searchText="searchText" :autoOpenDepth="autoOpenDepth" class="mt-2" />
          </div>
        </div>
      </div>

      <div class="col-9 px-5 py-3">
        <div v-if="Object.keys(selectedProject).length" class="row">
          <div class="col-12">
            <div class="row">
              <div class="col">
                <button v-if="selectedProject.write" @click="openModal(selectedProject.id, selectedProject.name, 'project', 'update')" type="button" class="btn btn-sm btn-outline-dark" data-bs-toggle="modal" data-bs-target="#projectEditModal" >&bull; {{ $t("general.update") }}</button>
              </div>
            </div>

            <!-- Name & Heading Data -->
            <div class="row mt-3">
              <div class="col">

                <div class="h4">{{ selectedProject.name }}</div>

                <!-- Folder description -->
                <div v-if="selectedProject.folder">
                  <div v-if="selectedProject.description" class="mt-3">
                    <QuillContent :content="this.selectedProject.description" />
                  </div>
                </div>

                <ul v-if="!selectedProject.folder" class="list-group list-group-horizontal-md foc-list-header">
                  <li class="list-group-item bg-white border-0">
                    <div class="foc-list-group-item-label">{{ $t("views.kpi.edit.responsible") }}:</div>
                    <div>{{ selectedProject.responsible.name }}</div>
                  </li>
                  <li class="list-group-item bg-white border-0">
                    <div class="foc-list-group-item-label">{{ $t("views.kpi.structure.validityPeriod") }}:</div>
                      <div>
                        <span v-if="selectedProject.validFrom"> {{ formatDate(new Date(selectedProject.validFrom)) }} - {{ formatDate(new Date(selectedProject.validTo)) }} </span>
                        <span v-else> {{ $t("views.strategy.structure.infinite") }} </span>
                      </div>
                  </li>
                </ul>

              </div>
            </div>
            <div v-if="!selectedProject.folder" class="row mt-3">
              <div class="col-12">
                <div class="card">
                  <div class="card-header fw-bold">{{ $t("views.project.detail.headingCard") }}</div>
                  <div class="card-body">
                    <ul class="nav nav-tabs border-bottom" role="tablist">
                      <li class="nav-item" role="presentation">
                        <button class="nav-link text-dark active" id="definition-tab" data-bs-toggle="tab" data-bs-target="#definition" type="button" role="tab" aria-controls="definition" aria-selected="false">{{ $t("views.project.detail.tabDefinition") }}</button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button class="nav-link text-dark" id="members-tab" data-bs-toggle="tab" data-bs-target="#members" type="button" role="tab" aria-controls="members" aria-selected="false">{{ $t("views.project.detail.tabMembers") }} <span v-if="selectedProject.members.length" class="badge bg-primary">{{ selectedProject.members.length}}</span></button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button class="nav-link text-dark" id="reviews-tab" data-bs-toggle="tab" data-bs-target="#reviews" type="button" role="tab" aria-controls="reviews" aria-selected="false">{{ $t("views.project.detail.tabReviews") }} <span v-if="selectedProject.reviews.length" class="badge bg-primary">{{ selectedProject.reviews.length}}</span></button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button class="nav-link text-dark" id="measures-tab" data-bs-toggle="tab" data-bs-target="#measures" type="button" role="tab" aria-controls="measures" aria-selected="false">{{ $t("views.project.detail.tabMeasures") }} <span v-if="selectedProject.measures.length" class="badge bg-primary">{{ selectedProject.measures.length}}</span></button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button class="nav-link text-dark" id="relationships-tab" data-bs-toggle="tab" data-bs-target="#relationships" type="button" role="tab" aria-controls="relationships" aria-selected="false">{{ $t("views.relationships.tabRelationships") }} <span v-if="selectedProject.relationships.length" class="badge bg-primary">{{ selectedProject.relationships.length}}</span></button>
                      </li>
                    </ul>
                    <div class="tab-content mt-2">
                      <div class="tab-pane fade show active" id="definition" role="tabpanel">
                        <div v-if="selectedProject.description" class="mt-3">
                          <QuillContent :content="selectedProject.description"></QuillContent>
                        </div>
                        <div v-else class="mt-3 h6">{{ $t("views.project.detail.noDescription") }}</div>
                      </div>

                      <div class="tab-pane fade" id="members" role="tabpanel">
                        <div v-if="selectedProject.write" class="row my-3">
                          <div class="col">
                            <button @click="openModal(false, '', 'member', 'add')" type="button" class="btn btn-sm btn-outline-primary" data-bs-toggle="modal" data-bs-target="#projectEditModal">+ {{ $t("general.add") }}</button>
                          </div>
                        </div>
                        <div v-if="selectedProject.members.length">
                          <table class="table">
                            <thead>
                              <tr class="border-dark">
                                <th scope="col">{{ $t("views.org.employee.name") }}</th>
                                <th scope="col">{{ $t("views.org.employee.email") }}</th>
                                <th scope="col">{{ $t("general.role") }}</th>
                                <th scope="col">{{ $t("general.headof") }}</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="member in selectedProject.members" :key="'member' + member.id">
                                <td>
                                  <div class="cont-icon-org-unit d-inline-block me-1">
                                    <svg class="bi" width="16" height="16" fill="currentColor"> <use xlink:href="@/assets/icons/icons.svg#employee-user" /> </svg> &nbsp;
                                    <a> {{ member.lastName }}, {{ member.firstName }} </a>
                                  </div>
                                </td>
                                <td>{{ member.email }}</td>
                                <td>{{ member.role }}</td>
                                <td class="ps-4">
                                  <span v-if="member.leadIndicator">
                                    <svg class="bi" width="18" height="18" fill="currentColor"> <use xlink:href="@/assets/icons/icons.svg#check"/> </svg>
                                  </span>
                                </td>
                                <td v-if="selectedProject.write">
                                  <div class="dropdown">
                                    <a href="#" class="ms-2 text-dark" data-bs-toggle="dropdown">
                                      <svg class="bi" width="28" height="28" fill="currentColor">
                                        <use xlink:href="@/assets/icons/icons.svg#three-dots"/>
                                      </svg>
                                    </a>
                                    <ul class="dropdown-menu">
                                      <li><a @click="openModal(member.id, member.firstName + ' ' + member.lastName, 'member', 'update', member.role)" class="dropdown-item" href="#projectEditModal" data-bs-toggle="modal">{{ $t("general.update") }}</a></li>
                                      <li><a @click="openModal(member.id, member.firstName + ' ' + member.lastName, 'member', 'remove', member.role)" class="dropdown-item" href="#projectDeleteModal" data-bs-toggle="modal">{{ $t("general.remove") }}</a></li>
                                    </ul>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div v-else class="mt-3 h6">{{ $t("views.project.detail.noMembers") }}</div>
                      </div>

                      <div class="tab-pane fade" id="reviews" role="tabpanel">
                        <div v-if="selectedProject.write" class="row my-3">
                          <div class="col">
                            <button @click="openModal(false, '', 'review', 'add')" type="button" class="btn btn-sm btn-outline-primary" data-bs-toggle="modal" data-bs-target="#projectEditModal">+ {{ $t("general.add") }}</button>
                          </div>
                        </div>
                        <div v-if="selectedProject.reviews.length">
                          <table class="table">
                            <thead>
                              <tr class="border-dark">
                                <th scope="col">{{ $t("views.objective.detail.reviewDate") }}</th>
                                <th scope="col">{{ $t("views.objective.detail.reviewAssessment") }}</th>
                                <th scope="col">{{ $t("views.objective.detail.reviewConversion") }}</th>
                                <th scope="col">{{ $t("views.objective.detail.reviewPrediction") }}</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="review in selectedProject.reviews" :key="'review' + review.id">
                                <th scope="row" class="fw-normal">{{ formatDate(new Date(review.date)) }} </th>
                                <td v-html="review.assessment" class="w-50"></td>
                                <td>
                                  <div class="progress position-relative border bg-dark border-dark w-50">
                                    <span class="progress-label position-absolute start-50 top-50 text-light fw-bold">{{ 25 * review.conversion }}%</span>
                                    <div class="progress-bar progress-bar-striped bg-primary" :style="'width: ' + (25 * review.conversion) + '%'" role="progressbar" :aria-valuenow="(25 * review.conversion)" aria-valuemin="0" aria-valuemax="100"></div>
                                  </div>
                                </td>
                                <td>
                                  <span class="badge fw-normal" :class="review.prediction === 'Y' ? 'text-bg-success' : review.prediction === 'D' ? 'text-bg-warning' : 'text-bg-danger'">
                                    {{ $t("views.project.detail.review.prediction." + review.prediction.toLowerCase()) }}
                                  </span>
                                </td>
                                <td v-if="selectedProject.write" class="text-end">
                                  <div class="dropdown">
                                    <a href="#" class="ms-2 text-dark" data-bs-toggle="dropdown">
                                      <svg class="bi" width="28" height="28" fill="currentColor">
                                        <use xlink:href="@/assets/icons/icons.svg#three-dots"/>
                                      </svg>
                                    </a>
                                    <ul class="dropdown-menu">
                                      <li><a @click="openModal(review.id, formatDate(new Date(review.date)) + ': ' + review.assessment, 'review', 'update')" class="dropdown-item" href="#projectEditModal" data-bs-toggle="modal">{{ $t("general.update") }}</a></li>
                                      <li><a @click="openModal(review.id, formatDate(new Date(review.date)) + ': ' + review.assessment, 'review', 'delete')" class="dropdown-item" href="#projectDeleteModal" data-bs-toggle="modal">{{ $t("general.delete") }}</a></li>
                                    </ul>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div v-else class="mt-3 h6">{{ $t("views.project.detail.noReviews") }}</div>
                      </div>
                      <div class="tab-pane fade" id="measures" role="tabpanel">
                        <div v-if="selectedProject.write" class="row my-3">
                          <div class="col">
                            <button @click="openModal(false, '', 'measure', 'add')" type="button" class="btn btn-sm btn-outline-primary" data-bs-toggle="modal" data-bs-target="#projectEditModal">+ {{ $t("general.add") }}</button>
                          </div>
                        </div>
                        <div v-if="selectedProject.measures.length">
                          <table class="table">
                            <thead>
                              <tr class="border-dark">
                                <th scope="col">{{ $t("views.objective.detail.measureTitle") }}</th>
                                <th scope="col">{{ $t("views.objective.detail.measureResponsible") }}</th>
                                <th scope="col">{{ $t("views.objective.detail.measureConversion") }}</th>
                                <th scope="col">{{ $t("views.objective.detail.measureValidFrom") }}</th>
                                <th scope="col">{{ $t("views.objective.detail.measureValidTo") }}</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="measure in selectedProject.measures" :key="'measure' + measure.id">
                                <th class="fw-normal" v-tooltip.bottom="{ key: 'tooltip.preview', params: { html: measure.measure } }">{{ measure.title }}</th>
                                <td>{{ measure.responsible.name }}</td>
                                <td>
                                  <div class="progress position-relative border bg-dark border-dark w-50">
                                    <span class="progress-label position-absolute start-50 top-50 text-light fw-bold">{{ 25 * measure.conversion }}%</span>
                                    <div class="progress-bar progress-bar-striped bg-primary" :style="'width: ' + (25 * measure.conversion) + '%'" role="progressbar" :aria-valuenow="(25 * measure.conversion)" aria-valuemin="0" aria-valuemax="100"></div>
                                  </div>
                                </td>
                                <td>{{ formatDate(new Date(measure.validFrom)) }}</td>
                                <td :class="new Date(measure.validTo) < new Date() ? 'text-danger' : 'text-dark'">{{ formatDate(new Date(measure.validTo)) }}</td>
                                <td v-if="selectedProject.write" class="text-end">
                                  <div class="dropdown">
                                    <a href="#" class="ms-2 text-dark" data-bs-toggle="dropdown">
                                      <svg class="bi" width="28" height="28" fill="currentColor">
                                        <use xlink:href="@/assets/icons/icons.svg#three-dots"/>
                                      </svg>
                                    </a>
                                    <ul class="dropdown-menu">
                                      <li><a @click="openModal(measure.id, measure.title, 'measure', 'update')" class="dropdown-item" href="#projectEditModal" data-bs-toggle="modal">{{ $t("general.update") }}</a></li>
                                      <li><a @click="openModal(measure.id, measure.title, 'measure', 'delete')" class="dropdown-item" href="#projectDeleteModal" data-bs-toggle="modal">{{ $t("general.delete") }}</a></li>
                                    </ul>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div v-else class="mt-3 h6">{{ $t("views.project.detail.noMeasures") }}</div>
                      </div>
                      <div class="tab-pane fade" id="relationships" role="tabpanel">
                        <div v-if="selectedProject.relationships.length">
                          <table class="table">
                            <thead>
                              <tr class="border-dark mt-3">
                                <th scope="col">{{ $t("views.relationships.headerLabel") }}</th>
                                <th scope="col">{{ $t("views.relationships.headerObject") }}</th>
                                <th scope="col">{{ $t("views.relationships.headerValidFrom") }}</th>
                                <th scope="col">{{ $t("views.relationships.headerValidTo") }}</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="relationship in selectedProject.relationships" :key="'relationship' + relationship.id">
                                <td v-if="relationship.type === 'objective'">
                                  <div class="cont-icon-org-unit d-inline-block me-1">
                                    <svg class="bi" width="16" height="16" fill="currentColor" v-tooltip="'tooltip.iconObjective'"> <use xlink:href="@/assets/icons/icons.svg#objective"/> </svg> &nbsp;
                                    {{ $t("views.relationships.projectStrategy") }}
                                  </div>
                                </td>
                                <td v-if="relationship.type === 'strategy'">
                                  <div class="cont-icon-org-unit d-inline-block me-1">
                                    <svg class="bi" width="16" height="16" fill="currentColor" v-tooltip="'tooltip.iconStrategy'"> <use xlink:href="@/assets/icons/icons.svg#strategy"/> </svg> &nbsp;
                                    {{ $t("views.relationships.projectStrategy") }}
                                  </div>
                                </td>
                                <td v-if="relationship.type === 'strategy'"> <a :href="createLink('strategy', relationship.strategyUuid)" target="_blank"> {{ relationship.name }} </a> </td>
                                <td>{{ formatDate(new Date(relationship.validFrom)) }}</td>
                                <td>{{ formatDate(new Date(relationship.validTo)) }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div v-else class="mt-3 h6">{{ $t("views.relationships.noRelationships") }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center mt-5">
          <img src="@/assets/img/no_data.svg" class="img-fluid" width="250">
          <p v-if="'nodes' in projects && projects.nodes.length" class="h5 mt-3">{{ $t("views.project.structure.helpChooseProject") }}</p>
          <p v-else class="h5 mt-3">{{ $t("views.project.structure.helpCreateProject") }}</p>
        </div>
        <ProjectEditModal></ProjectEditModal>
        <ProjectDeleteModal></ProjectDeleteModal>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectTree from '@/components/projects/ProjectTree.vue'
import ProjectEditModal from '@/components/projects/ProjectEditModal.vue'
import ProjectDeleteModal from '@/components/projects/ProjectDeleteModal.vue'
import QuillContent from '@/components/QuillContent.vue'
import * as formatUtils from '@/composables/formatUtils'
import * as tree from '@/composables/tree'

export default {
  name: 'ProjectManageProject',
  data () {
    return {
      projectModalElementId: false,
      projectModalElementType: '',
      projectModalMode: '',
      selectedElement: '',
      filterValidFrom: this.$store.state.user?.settings?.favorites?.projectManage?.filterValidFrom ? this.$store.state.user.settings.favorites.projectManage.filterValidFrom : new Date().getFullYear().toString() + '-01-01',
      filterValidTo: this.$store.state.user?.settings?.favorites?.projectManage?.filterValidTo ? this.$store.state.user.settings.favorites.projectManage.filterValidTo : (new Date().getFullYear() + 1).toString() + '-12-31',
      searchText: '',
      autoOpenDepth: 2,
      sliderKey: 0
    }
  },
  components: {
    ProjectTree,
    ProjectEditModal,
    ProjectDeleteModal,
    QuillContent
  },
  computed: {
    sysParms () {
      return this.$store.state.sysParms
    },
    projects () {
      return this.$store.state.projects.constructor === Array ? [] : this.$store.state.projects
    },
    selectedProject () {
      return this.$store.state.selectedProject
    },

    // maximale Strukturtiefe ermitteln (Fallback 2)
    maxTreeDepth () {
      return tree.getMaxTreeDepth(this.$store.state.projects?.nodes, 2)
    }

  },

  watch: {
    'projects.nodes': {
      handler (nodes) {
        if (!nodes || nodes.length === 0) return

        // Set Slider Default-Level (Fallback = 2)
        const depth = this.maxTreeDepth
        const defaultLevel = this.sysParms?.projectTreeDefaultLevel ?? 2
        this.autoOpenDepth = Math.min(Math.max(defaultLevel, 2), depth)

        // Render Slider
        this.sliderKey++
      },
      immediate: true
    }
  },

  methods: {
    async filterProjects (filterFrom, filterTo) {
      this.$store.commit('SET_LOADING_STATUS', true)
      this.filterValidFrom = filterFrom
      this.filterValidTo = filterTo
      await this.$store.dispatch('getProjects', { validFrom: filterFrom, validTo: filterTo })
      await this.$store.dispatch('favoriteObject', { isList: false, objectKey: 'projectManage', objectValue: { filterValidFrom: filterFrom, filterValidTo: filterTo } })
      this.$store.commit('SET_LOADING_STATUS', false)
    },
    createLink (type, uuid) {
      let url = ''
      if (type === 'strategy') url = '/strategies/manage/strategies?id=' + uuid
      if (type === 'employee') url = '/organization/manage/employees?id=' + uuid
      return url
    },
    openModal (id, name, elementType, mode, role) {
      if (id) {
        this.projectModalElementId = id
      }
      if (name) {
        this.projectModalElementName = name.replace(/<[^>]*>/g, '') // Convert name from html to plaintext
        this.projectModalElementName = this.projectModalElementName + ', ' + role
      }
      this.projectModalElementType = elementType
      this.projectModalMode = mode
      this.projectModalElementRole = role
    },
    formatDate (date) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.formatDate(userLocale, date)
    },
    async selectEmployee (employeeId) {
      this.$store.commit('SET_LOADING_STATUS', true)
      await this.$store.dispatch('getEmployee', employeeId).then(() => {
        this.$router.push({ name: 'OrgManageEmployee' })
      })
      this.$store.commit('SET_LOADING_STATUS', false)
    }
  },

  async created () {
    this.$store.commit('SET_LOADING_STATUS', true)

    // check query params for selected Project
    let paramSelectedProject = ''
    if (this.$route.query.id) {
      paramSelectedProject = this.$route.query.id
    }

    // get filter values from param object
    if (paramSelectedProject !== '') {
      await this.$store.dispatch('getProject', paramSelectedProject)
      this.searchText = this.selectedProject.name
      this.filterValidFrom = this.selectedProject.validFrom
      this.filterValidTo = this.selectedProject.validTo
    }

    await this.$store.dispatch('getProjects', { validFrom: this.filterValidFrom, validTo: this.filterValidTo })

    if (Object.keys(this.selectedProject).length) {
      await this.$store.dispatch('getProject', this.selectedProject.id)
    }
    await this.$store.dispatch('getEmployees', { mode: 'default' })
    this.$store.commit('SET_LOADING_STATUS', false)
  }
}
</script>

<style lang="scss" scoped>
.progress-label {
  transform: translate(-50%, -50%);
}
.tab-content .progress {
  margin-top: 6px;
}

</style>
